import { Link, useLocation } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-24 text-center">
        <p className="font-heading font-black text-6xl md:text-8xl text-primary-100 select-none">404</p>
        <h1 className="mt-4 font-heading font-extrabold text-2xl md:text-3xl text-foreground-950">
          页面走丢了
        </h1>
        <p className="mt-3 text-sm md:text-base text-foreground-500">
          你访问的页面不存在或已被移除：
          <span className="font-mono text-foreground-400 ml-1 break-all">{location.pathname}</span>
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md border border-background-300 text-sm font-medium text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-list-check-2"></i>
            浏览全部赛事
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}